<p-toast></p-toast>
<p-toolbar styleClass="p-mb-4">
    <ng-template pTemplate="left">
        <button *ngIf="device != '2'" pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left"
            class="p-button-warning p-mr-2" (click)="goBack()"></button>
    </ng-template>

</p-toolbar>

<div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
    <label for="opt">{{lbl_language}}</label>
    <div class="p-col-6 p-md-10">
        <p-dropdown [options]="listLanguage" [(ngModel)]="selectedLanguage" optionLabel="value" [showClear]="true"
            placeholder="{{lbl_language}}" (onChange)="getItemList()"></p-dropdown>
    </div>
</div>

<div class="pages-body login-page p-d-flex p-flex-column">

    <div class="topbar p-px-2 p-d-flex p-jc-between p-flex-row p-ai-center">


    </div>
    <div class="col-12">
        <div class="card">
            <p-table #dt [value]="items" responsiveLayout="scroll" [globalFilterFields]="['sellUM','descri']">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <!--  <h5 class="m-0"><span>{{lbl_guide}} </span> <span class="p-text-bold">{{guide != null ?
                                guide.name : ""}} {{guide != null ? guide.lastName :""}}</span></h5>
-->
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{lbl_search}} Items ...." />
                        </span>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <p-autoComplete placeholder="{{lbl_search}} {{lbl_track}} ...."
                                [(ngModel)]="selectedItemsTrak" [showEmptyMessage]="true"
                                [suggestions]="filteredItemsTrack" (completeMethod)="filterItemsTrack($event)"
                                field="name" [minLength]="1" (ngModelChange)="redirectDtl($event)">
                            </p-autoComplete>
                        </span>
                    </div>

                    <div class="p-col-8 p-md-6" *ngIf="this.existsGuiMsg">
                        <span class="p-text-bold p-error">{{guideMessage}}</span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{lbl_name}}</th>
                        <th>{{lbl_photo}}</th>


                        <th style="width:6rem">{{lbl_select}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>{{product.value}}</td>
                        <td><img [src]="product.imageB64" [alt]="product.value" width="100" class="shadow-4" />

                            <p-fileUpload mode="basic" icon="pi pi-plus" maxFileSize="5000000"
                                (onSelect)="uploadItemPhoto($event,product)" [auto]="true"
                                *ngIf="showInternatColumns" chooseLabel="{{lbl_upload_file}} JPG"
                                accept="image/jpeg"></p-fileUpload>
                        </td>

                        <td>
                            <button type="button" pButton pRipple icon="pi pi-search"
                                (click)="selectRecord(product.valueId)"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{lbl_there_are}} {{items ? items.length : 0 }} {{lbl_item}}. (240426)
                    </div>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>